const ShowcaseSchema = ({images}) => {

    const getImages = () => {
        let arr = [];
        images.map((image) => {
            arr.push({
                "type": "ImageObject",
                "url": image.image,
                "caption": image.title
            })
        })
        return JSON.stringify(arr);
    }

    var json_ld = {
        "@context": "https://schema.org/",
        "@type": "CollectionPage",
        "url": `${process.env.NEXT_PUBLIC_HOME_URL}/gallery`,
        "description": `Image Gallery of ${process.env.brand.brand_name} with the links to the products related to the images displayed`,
        "mainEntityOfPage": {
            "@type": "ImageGallery",
            "image": getImages()
        }
    };

    const productJsonId = {
        __html: JSON.stringify(json_ld),
    };
    
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={productJsonId}
            id="product-jsonld"
            key="product-jsonld"
        />
    );
};

export default ShowcaseSchema;
